module.exports = __webpack_public_path__ + "img/credential-text-digital-marketing.91115ec3f51ef84937ee8971a8d4e43a.svg";